import script from "./FolderItemCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderItemCount.vue?vue&type=script&lang=js"
export * from "./FolderItemCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FolderItemCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/FolderItemCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "251f5d9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('251f5d9d', __exports__)) {
    api.reload('251f5d9d', __exports__)
  }
  
}


export default __exports__